import { XClose } from "untitledui-js-base";

import { ApplicantType } from "shared/types";
import { SelfServeOption } from "../../../types";

import { ManualOption } from "../../../types";
import { Mail01, Pencil01 } from "untitledui-js-base";
import { IconButton, IconButtonVariant } from "shared/components/IconButton";
import { RoleSelect } from "./RoleSelect";
import { TemplateBaseSetting } from "types/landlord/verificationTemplate";

export const ApplicantToAddRow = ({
  option,
  onRemove,
  options,
  updateOption,
  template
}: {
  option: ManualOption | SelfServeOption;
  onRemove: () => void;
  options: (ManualOption | SelfServeOption)[];
  updateOption: (option: ManualOption | SelfServeOption) => void;
  template?: Record<ApplicantType, TemplateBaseSetting>;
}) => {
  const isApplicantOrOccupant = (role: ApplicantType) =>
    [ApplicantType.Applicant, ApplicantType.Occupant].includes(role);

  const isGuarantorDisabled =
    options.filter((o) => isApplicantOrOccupant(o.role)).length === 1 &&
    isApplicantOrOccupant(option.role);

  const numberOfApplicantsOrOccupants = options.filter((o) =>
    isApplicantOrOccupant(o.role)
  ).length;

  return (
    <div className="flex items-center justify-between mb-4">
      <div className="flex items-center gap-2">
        <div className="h-10 w-10 bg-primary-50 rounded-lg flex items-center justify-center">
          {option.type === "self-serve" ? (
            <Mail01 className="w-5 h-5 stroke-primary-500" />
          ) : (
            <Pencil01 className="w-5 h-5 stroke-primary-500" />
          )}
        </div>
        <div className="text-sm">
          {option.type === "self-serve" ? (
            <>
              <p className="font-medium text-content-1000">{option.email}</p>
              <p className="text-content-400">Self-serve application</p>
            </>
          ) : (
            <>
              <p className="font-medium text-content-1000">
                {option.first_name} {option.last_name}
              </p>
              <p className="text-content-400">Manual application</p>
            </>
          )}
        </div>
      </div>
      <div className="flex items-center gap-2">
        <RoleSelect
          className="mt-2 min-w-[180px]"
          value={option.role}
          onChange={(role) =>
            updateOption({
              ...option,
              role
            })
          }
          template={template}
          isDisabled={false}
          disabledRoles={isGuarantorDisabled ? [ApplicantType.CoSigner] : []}
        />

        <IconButton
          Icon={XClose}
          disabled={
            numberOfApplicantsOrOccupants <= 1 &&
            isApplicantOrOccupant(option.role)
          }
          variant={IconButtonVariant.BASE}
          onClick={onRemove}
        />
      </div>
    </div>
  );
};
